
import Vue from 'vue'
import Component from 'vue-class-component'
import {Prop} from 'vue-property-decorator'
import api from '../../api'
import {TemplateDesignPageInfo} from './TemplateDesign.vue'

@Component
export default class TemplateDesignHeader extends Vue {
  @Prop({type: Object, required: true}) context!: TemplateDesignPageInfo
  @Prop({type: String, required: true}) company!: string
  /**
   * 웹파트 템플릿 개인화를 위한 환경인지 여부
   * 개인화인 경우 일부 관리적 기능이 제한됨
   */
  @Prop({type: Boolean, default: false}) personal!: boolean
}
